import $ from 'jquery';

var fileViewerModalInitialised = false;

export function initFileViewerModal(){
  if ( !fileViewerModalInitialised ){
    
    /**
     * When we load a PDF file check for errors 
     */
    $("#fileViewerPDFElement", "#fileViewerModal").on("load", function(e){        
      var iframedocument = $(this).contents().get(0);
      
      var contentType = "";
      if ( typeof iframedocument !== "undefined" ){
          contentType = iframedocument.contentType || iframedocument.mimeType;                    
      }
              
      if ( contentType === "application/json" ){
          $("#fileViewerPDFElement", "#fileViewerModal").hide();
          $("#fileViewerModalDownload", "#fileViewerModal").hide();
          var responseJSON = $.parseJSON( $( this ).contents().text() );
          processStandardAjaxResponse( responseJSON );
                      
      } else {
          $("#fileViewerPDFElement", "#fileViewerModal").show();
          $("#fileViewerModalDownload", "#fileViewerModal").show();
      }     
    });
    
    /**
     * If the download button is clicked, trigger a download
     */
    $("#fileViewerModal").on("click", "#fileViewerModalDownload", function(e){        
      let downloadHref = $(this).attr("href");
      triggerFileDownload(downloadHref);
    });
    
    /**
     * Upon modal close clear out the modal of any data
     */
    $("#fileViewerModal").on("hidden.bs.modal", function(e){
      $("#fileViewerImageElement", "#fileViewerModal").attr("src", "");
      $("#fileViewerImageElement", "#fileViewerModal").hide();
      $("#fileViewerPDFElement", "#fileViewerModal").attr("src", "");
      $("#fileViewerPDFElement", "#fileViewerModal").hide();
      $("#fileViewerMessage", "#fileViewerModal").hide();
    });
    
    fileViewerModalInitialised = true;
  }
}


export function triggerFileDownload( href ){
  location.href = href;
}

export function showFileViewerModal(title, fileType, viewHref, downloadHref, filePath){

  $("#fileViewerModalTitle", "#fileViewerModal").text(title);

  if( fileType == fileViewerTypeImage ){
      $("#fileViewerPDFElement", "#fileViewerModal").hide();
      
      $("#fileViewerImageElement", "#fileViewerModal").attr("src", viewHref);
      $("#fileViewerModalDownload", "#fileViewerModal").attr("href", downloadHref);            
      $("#fileViewerImageElement", "#fileViewerModal").show();
      $("#fileViewerModalDownload", "#fileViewerModal").show();
  } else if(fileType == fileViewerTypePDF ) {
      $("#fileViewerImageElement", "#fileViewerModal").hide();
      
      $("#fileViewerPDFElement", "#fileViewerModal").attr("src", viewHref);
      $("#fileViewerModalDownload", "#fileViewerModal").attr("href", downloadHref);
      $("#fileViewerPDFElement", "#fileViewerModal").show();
      
  } else {
      return;
  }

  $('#fileViewerModal').modal('show');
}
